import { SchemaValidator } from '../../../../global/SchemaValidator';
import { runtimeSchema } from '../schema';
import { RuntimeModel } from '../../types';
import { runtime, getLoadStartPoint } from '../../../../utils/equation';
import { getDataPoints } from '../../../../utils/utils';

export const getRuntimeModel = (obj: unknown): RuntimeModel => {
  const schemaValidator = new SchemaValidator(runtimeSchema);
  if (!schemaValidator.validate(obj)) {
    throw schemaValidator.errors;
  }

  const runtimeModel = obj as RuntimeModel;
  const { translations } = runtimeModel as RuntimeModel & {
    translations: {
      powerW: string;
      powerkW: string;
      timeMin: string;
      timeSec: string;
      timeH: string;
    };
  };

  runtimeModel.translations.power = {
    abbr: {
      watts: translations.powerW,
      kWatts: translations.powerkW,
    },
  };

  runtimeModel.translations.time = {
    abbr: {
      hour: translations.timeH,
      min: translations.timeMin,
      sec: translations.timeSec,
    },
  };

  // throw if runtime equation returns runtime less than or equal to 0
  const labels = getDataPoints(
    getLoadStartPoint(runtimeModel),
    runtimeModel.product.pwrRated,
    180,
  );

  const runtimeFunction = runtime(runtimeModel.product);
  if (
    labels.some((x) => {
      const runtime = runtimeFunction(x);
      return runtime <= 0;
    })
  ) {
    throw new Error('Runtime coefficients produced negative runtime');
  }

  runtimeModel.bundles.forEach((bundle) => {
    const runtimeFunction = runtime({
      ...runtimeModel.product,
      vah: bundle.vah,
    });
    if (
      labels.some((x) => {
        return runtimeFunction(x) <= 0;
      })
    ) {
      throw new Error('Runtime bundle coefficients produced negative runtime');
    }
  });

  return runtimeModel;
};
